import { axiosInstance } from "../network";
import { API_URL } from "../../constants";

export default {
  getAllBusiness: () => {
    return axiosInstance.get(API_URL.BUSINESS_SELECTION, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  },
};
